export default {
  name: '',
  code: '',
  active: true,
  parentId: '',
  dependFrom: {}
};